var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"access-denied text-center"},[_c('h1',[_vm._v("접근 권한이 없습니다")]),_c('p',[_vm._v("이 페이지에 접근할 권한이 없습니다. 관리자에게 문의하시기 바랍니다.")]),_c('button',{staticClass:"btn-back",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("뒤로가기")])])
}
var staticRenderFns = []

export { render, staticRenderFns }